










































import NumberplateForm from "@/components/utility/NumberplateForm.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    LayoutReportStep,
    NumberplateForm
  }
})
export default class ReportWrapping extends ReportStepMixin implements IReportStep {
  public md = 4;
  public static screenName = ReportScreenEnum.wrapping;
  public header: IReportHeaderData = {
    title: "report.ReportWrapping.title",
    description: "report.ReportWrapping.description"
  };
  screen = ReportScreenEnum.wrapping;

  isValid = false;

  get isDone() {
    return this.isValid;
  }

  get isWrapped(): boolean | undefined {
    return ReportModule.isWrapped;
  }

  set isWrapped(value: boolean | undefined) {
    if (value === false) {
      this.isWrapDamaged = false; // Default to false if undefined
    }
    ReportModule.setIsWrapped(value);
  }

  get isWrapDamaged(): boolean | undefined {
    return ReportModule.isWrapDamaged;
  }

  set isWrapDamaged(value: boolean | undefined) {
    ReportModule.setIsWrapDamaged(value);
  }

  mounted() {
    if (ReportModule.isWrapped === undefined) {
      ReportModule.setIsWrapped(false);
    }

    if (ReportModule.isWrapDamaged === undefined) {
      ReportModule.setIsWrapDamaged(false);
    }
  }
}
